/* eslint-disable react/display-name */
import React from 'react'
import { SelectLabelProps } from './interface'
import Single from './Single'
import './selectLabel.css'
import Multi from './Multi'

export const defaultDropIcon = (
  <svg
    viewBox="0 0 1024 1024"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    className="zySelectLabelDropIcon"
  >
    <path d="M706.56 386.56a41.6 41.6 0 0 1 63.232 53.76l-4.352 5.12-224 224a41.6 41.6 0 0 1-53.76 4.352l-5.12-4.352-224-224a41.6 41.6 0 0 1 53.76-63.232l5.12 4.352L512 581.184l194.56-194.56z" />
  </svg>
)

export const defaultClearIcon = (
  <svg
    viewBox="0 0 1024 1024"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    className="zySelectLabelClearIcon"
    data-popup-open={false}
  >
    <path
      data-popup-open={false}
      d="M512 64a448 448 0 1 1 0 896A448 448 0 0 1 512 64zM370.176 325.696a32 32 0 0 0-40.832 48.96L466.752 512l-137.408 137.344-3.648 4.48a32 32 0 0 0 48.96 40.832L512 557.248l137.344 137.408 4.48 3.648a32 32 0 0 0 40.832-48.96L557.248 512l137.408-137.344 3.648-4.48a32 32 0 0 0-48.96-40.832L512 466.752 374.656 329.344z"
    />
  </svg>
)

const SelectLabel = <V = unknown, >(props: SelectLabelProps<V>) => {
  return <Single {...props} />
}

SelectLabel.Multi = <V = unknown>(props: SelectLabelProps<V[]>) => {
  return <Multi<V[]> {...props} />
}

export default SelectLabel
